<template>
  <div class="feedback-content">
    <span class="feedback-content__title">Tell us what you'd like to change in the description of this trip.</span>
    <textarea
      ref="textarea"
      v-model="description"
      class="feedback-content__textarea"
      placeholder="e.g., I want the timeline to be written in more detail"
    />

    <Button color="red" @click="handleChangeWordingOfDescriptionsNext" :disabled="loading || !description"
      >Send request</Button
    >
    <span class="feedback-content__cancel" @click="emits('go-to-stage', Stages.CHANGE_SOMETHING)">Back</span>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Product } from 'app/javascript/src/models'
import { useTypedItineraryStore } from 'app/javascript/src/stores/typed'
import { useAuthUserState } from 'app/javascript/src/stores'
import api from 'app/javascript/src/utils/api'
import { redirectTo } from 'app/javascript/src/utils/functions'
import { Selections } from './types'
import { Stages } from './types'
import Button from '@/components/Theme2/Button.vue'
import { logErrorOnSentry } from 'app/javascript/src/utils/errorReportingUtils'
import { useShared } from 'app/javascript/src/helpers/vueHelpers'

const emits = defineEmits<{
  (e: 'go-to-stage', stage: Stages): void
}>()

const itineraryStore = useTypedItineraryStore<Product>()
const userAuth = useAuthUserState()
const { componentInfo } = useShared()

const description = ref('')
const loading = ref(false)

const handleChangeWordingOfDescriptionsNext = async () => {
  if (!itineraryStore.data) {
    return
  }

  try {
    loading.value = true
    await api.post(`/api/chatrooms/${itineraryStore.chatroomId}/messages/self_serve_message`, {
      selections: [Selections.CHANGE_WORDING_OR_DESCRIPTIONS],
      content: description.value,
      sender_name: userAuth.name.value,
    })

    redirectTo(`/travelers/messages?itineraryRequestId=${itineraryStore.data.itineraryRequestId}`)
  } catch (error) {
    logErrorOnSentry(error, componentInfo)
    loading.value = false
  }
}
</script>
